import { Link } from 'react-router-dom';
import { campaignCategories } from '@/mocks/homeData';

export default function CampaignCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-50 text-secondary-600 text-xs font-semibold rounded-full mb-3">
            Campaign Categories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Choose a <span className="gradient-text">Cause</span> Close to Your Heart
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Browse campaigns by category and find the cause that resonates with you the most.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {campaignCategories.map((category, index) => (
            <Link
              key={index}
              to={`/campaigns?category=${category.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-2xl bg-background-50 hover:shadow-sm transition-all duration-300 border border-transparent hover:border-foreground-200/60"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl ${category.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${category.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              <h4 className="text-foreground-900 font-semibold text-xs md:text-sm">{category.name}</h4>
              <span className="text-foreground-400 text-[11px] mt-1">{category.count} campaigns</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}